export default "__VITE_ASSET__T5iIHYSYe26skCMLnk6HyA__"